import { GptTTSModelTypeArr, GTPChatModelType, OLlamaChatModelType } from './ChatbotConfig.js';

const OldLanguageModels = ["qwen3.8-27b", "gpt-3.5-turbo", "gpt-4-turbo", "text-davinci-003"] as const;
type OldLanguageModelsType = typeof OldLanguageModels[number];
const OldAudioModels = ["whisper-1"] as const;
type OldAudioModelsType = typeof OldAudioModels[number];

export const prices: {
    languageModels: {
        [k in (GTPChatModelType | OLlamaChatModelType | OldLanguageModelsType)]: {
            input: number,
            output: number
        }
    },
    audioModels: {
        [k in (typeof GptTTSModelTypeArr[number] | OldAudioModelsType)]: {
            usage: number
        }
    },
    avatarModels: {
        heygen: {
            usage: number
        }
    }
} = {
    languageModels: {
        "qwen3.8-27b": {
            input: 0,
            output: 0
        },
        "gpt-4-turbo": {
            input: 10,
            output: 30
        },
        "gpt-4o": {
            input: 2.5,
            output: 10
        },
        "gpt-4o-mini": {
            input: 0.15,
            output: 0.60
        },
        "gpt-4.1": {
            input: 2,
            output: 8
        },
        "gpt-4.1-mini": {
            input: 0.4,
            output: 1.6
        },
        "gpt-4.1-nano": {
            input: 0.1,
            output: 0.4
        },
        "gpt-5": {
            input: 1.25,
            output: 10
        },
        "gpt-5-mini": {
            input: 0.25,
            output: 2
        },
        "gpt-5-nano": {
            input: 0.05,
            output: 0.4
        },
        "gpt-5.1": {
            input: 1.25,
            output: 10
        },
        "gpt-5.2": {
            input: 1.25,
            output: 10
        },
        "gpt-5.4": {
            input: 1.25,
            output: 10
        },
        "gpt-5.4-mini": {
            input: 0.25,
            output: 2
        },
        "gpt-5.4-nano": {
            input: 0.05,
            output: 0.4
        },
        "gpt-5.5": {
            input: 5,
            output: 30
        },
        "gpt-5.5-pro": {
            input: 30,
            output: 180
        },
        "gpt-5.6": {
            input: 5,
            output: 30
        },
        "gpt-5.6-sol": {
            input: 5,
            output: 30
        },
        "gpt-5.6-terra": {
            input: 2,
            output: 12
        },
        "gpt-5.6-luna": {
            input: 0.20,
            output: 1.20
        },
        "gpt-6-astra": {
            input: 10,
            output: 50
        },
        "gpt-3.5-turbo": {
            input: 1.125,
            output: 2
        },
        "text-davinci-003": {
            input: 20,
            output: 20
        },
        "deepseek-r1:8b": {
            input: 0,
            output: 0
        },
        "deepseek-r1:14b": {
            input: 0,
            output: 0
        },
        "gemma3:4b": {
            input: 0,
            output: 0
        },
        "llama3.2:3b": {
            input: 0,
            output: 0
        },
        "mistral:7b": {
            input: 0,
            output: 0
        },
        "qwen2.5vl:7b": {
            input: 0,
            output: 0
        },
        "gpt-oss:20b": {
            input: 0,
            output: 0
        }
    },
    audioModels: {
        "whisper-1": {
            usage: 0.006 //per minute
        },
        "tts-1": {
            usage: 15 //per 1 Mio Token
        },
        "gpt-4o-mini-tts": {
            usage: 12 //per 1 Mio Characters
        }
    },
    avatarModels: {
        "heygen": {
            usage: 99 //per 100 Token
        }
    }
};